// // frontend/src/utlis/formateDateTime.js

// import { useLocation } from "react-router-dom";

// export const formatDateTime = (dateString) => {
//   if (!dateString) return '—';
//   return new Date(dateString).toLocaleString('en-IN', {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit',
//     // hour12: false,
//   });
// };

// utils/useFormatDateTime.js

import { useLocation } from "react-router-dom";

export const formatDateTime = (dateString) => {
  const location = useLocation();
  if (!dateString) return "—";

  const isReportPage = location.pathname.includes("reports");

  if (isReportPage) {
    console.log("isReportPage", isReportPage);
    // Handle Excel-style date: ="17-12-2025 04:48:13.770 PM"
    let cleaned = dateString.replace(/^="?|"?$/g, ""); // remove = and quotes

    // Split date and time
    const [datePart, timePart, meridian] = cleaned.split(/[\s]+/);
    const [day, month, year] = datePart.split("-");
    let [hour, minute, second] = timePart.split(":").map(Number);

    // Convert to 24-hour format
    if (meridian.toUpperCase() === "PM" && hour < 12) hour += 12;
    if (meridian.toUpperCase() === "AM" && hour === 12) hour = 0;

    const isoString = `${year}-${month}-${day}T${hour
      .toString()
      .padStart(2, "0")}:${minute.toString().padStart(2, "0")}:${second
      .toString()
      .padStart(2, "0")}`;

    console.log("isoString", isoString);

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "—";

    return dateObj.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  } else {
    const dateObj = new Date(dateString);
    if (isNaN(dateObj)) return "—";

    return dateObj.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }
};
